import { callService } from "./segimientoSiniestroTools";
import { servicios } from "../../properties";
import axios from 'axios';

const MSG_LOG_ERROR_GET_SINIESTRO= "Hubo un error al obtener el siniestro seleccionado. Favor de intentar más tarde.";

export const cargarReembolsos = (polizas) => {
	return dispatch => {  
		new callService({
			service: "siniestrosReembolsos.listaSiniestros",
			"secure": true,
			data: {polizas: polizas}
		}).execute().then(body=>{
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_SINIESTROSREM",
				"sreembolsos": body
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ 
				"type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Error", 
				"mensaje" : "Hubo un error al obtener los siniestros de reembolsos. Favor de intentar más tarde." 
			});
		});
	};
};

const getSiniestros = (payload) =>{
	const siniestros = []; 
	let aviso = false;
	for (var siniestro of Object.keys(payload) ) {
		if(payload[siniestro].length > 0)
		{
			for(var sin of payload[siniestro])
			{							
				siniestros.push(sin);
				//Ingreso al centro de reparación
				if (sin.tramoStatus && sin.tramoStatus === "Ingreso al centro de reparación"){
				aviso = true;
				}
			}
		}
	}
	return {siniestros, aviso};
}

const validStatusPagoSiniestros = (siniestros, siniestrosEstatusPago) =>{
	let siniestrosValidados = [];
	siniestrosValidados = siniestros.map(siniestro =>{
		for(var siniestroEstatus of siniestrosEstatusPago){						
			if(siniestro.codSiniestroPadre === siniestroEstatus.numeroSiniestro && siniestroEstatus.estatus === "Por Pagar"){
				siniestro.estatusPago = true;
				break;	
			}else{
				siniestro.estatusPago = false;
			}
		}
		return siniestro;
	});
	return siniestrosValidados;
}

export const historicoSiniestros = (polizas, tokId) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: "seguimientoSiniestro.historicoSiniestros",
			"secure": true,
			data: polizas
		}).execute().then(body=>{
			var siniestros = [];
			var aviso = false;
			var payload = body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null;			
			if(payload){
				const result = getSiniestros(payload);
				siniestros = result.siniestros;
				aviso = result.aviso;
				var arrayStatus = siniestros.map( siniestro => {
					return siniestro.codSiniestroPadre;
				});
				axios({
					method: 'POST',
					url: `${servicios.pagoDeducibleAutos.urlBaseCF}/pagoDeducibleAuto/estatusPago`,
					headers:{
						authorization: tokId
					},
					data: {
						siniestros: arrayStatus
					}
				}).then(responseEstatusPago  => {
					const siniestrosEstatusPago = responseEstatusPago.data.siniestros;
					
					siniestros = validStatusPagoSiniestros(siniestros, siniestrosEstatusPago);			
					dispatch({
						"type": "SINIESTROS_SET_SINIESTROSREP",
						"objetoSReparacion": payload,
						"sreparacion": siniestros,
						"aviso": aviso,
					});
					redux.dispatch({"type": "LOADER", "show": false});
				}).catch( error => {
					redux.dispatch({"type": "LOADER", "show": false});
					dispatch({
						"type": "SINIESTROS_SET_SINIESTROSREP",
						"objetoSReparacion": payload,
						"sreparacion": siniestros,
						"aviso": aviso,
					});
				});
			}else{
				dispatch({
					"type": "SINIESTROS_SET_SINIESTROSREP",
					"sreparacion": [],					
				});
			}
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ 
				"type": "MODAL_ALERT_MESSAGES_SHOW", 
				"titulo": "Error", 
				"mensaje" : "Hubo un error al obtener los siniestros. Favor de intentar más tarde." 
			});
		});
	};
};

export const detalleSiniestro = (numPoliza, fchInicio, fchFin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.consultaSiniestroPorPoliza}/${numPoliza}/siniestros/historico/fchInicio/${fchInicio}/fchFin/${fchFin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTROREP",
				"detalle": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO,
				  });
		});
	};
};

export const detalleValuacion = (codSiniestro, vin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detalleValuacion}/${codSiniestro}/vin/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_VALUACION",
				"valuacion": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO,
				  });
		});
	};
};

export const detalleReparacion = (codSiniestro, vin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detalleReparacion}/${codSiniestro}/vin/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_REPARACION",
				"reparacion": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO,
				  });
		});
	};
};

export const detallePagos = (codSiniestro, vin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detallePagos}/${codSiniestro}/vin/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_PAGOS",
				"pagos": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO, 
				  });
		});
	};
};

export const detalleRobos = (codSiniestro, vin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detalleRobos}/${codSiniestro}/vin/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_ROBOS",
				"robos": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO, 
				  });
		});
	};
};

export const detallePT = (codSiniestro, vin) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	redux.dispatch({"type": "LOADER", "show": true});
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detallePT}/${codSiniestro}/vin/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_PT",
				"pt": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO, 
				  });
		});
	};
};

export const detalleSiniestroSeg = (codSiniestro, vin, isMobile = false) => {
	var redux = angular.element(document.querySelector("ui-view")).scope().$parent
    .state.redux;
	if(!isMobile) {
		redux.dispatch({"type": "LOADER", "show": true});
	}
	return dispatch => {
		new callService({
			service: `${servicios.seguimientoSiniestro.detalleSiniestro}/${codSiniestro}/${vin}`,
			"secure": true,
			rawUrl: true,
			method: 'GET'
		}).execute().then(body=>{
			redux.dispatch({"type": "LOADER", "show": false});
			console.log("Response: ", JSON.stringify(body));
			dispatch({
				"type": "SINIESTROS_SET_DETALLE_SINIESTRO_SEG",
				"siniestro": body.payload && (!Array.isArray(body.payload) || body.payload.length) ? body.payload : null
			});
		}).catch(error => {
			console.log("Error: ", JSON.stringify(error));
			redux.dispatch({"type": "LOADER", "show": false});
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
					  "titulo": "Error", 
					  "mensaje" : MSG_LOG_ERROR_GET_SINIESTRO,
				  });
		});
	};
};



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimientoSiniestro/seguimientoSiniestro.act.js